<template>
  <div
    class="p-contentplans-writing-user-headings-item--view"
    :data-level="level"
  >
    <p class="p-contentplans-writing-user-headings-item--view__label">
      <HeadingType :level="level" />
    </p>
    <p class="p-contentplans-writing-user-headings-item--view__text">
      {{ value }}
    </p>
  </div>
</template>

<script>
import HeadingType from '@/components/HeadingType';

export default {
  props: {
    level: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  components: {
    HeadingType
  }
};
</script>
